import skarrePic from "@/public/images/artists/skarre.png";
import { Artist } from "@/types/types";

export const skarre = {
  id: "284",
  name: "Skarre",
  image: skarrePic,
  description: `Skarre has a sharp, soaring voice with smooth control and the ability to push into strong, emotional belts.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fskarre-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Belting", "Rock", "Ballads", "Folk", "Country"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 51,
        high: 70,
      },
      sweetSpot: 61,
    },
  },
} satisfies Artist;
